/** PM Scroll Utilities — scroll management for messages and threads. */

window.scroll_thread_to_middle = function(thread) {
  var container = document.getElementById('threads_left');
  var el = thread instanceof $ ? thread[0] : thread;
  if (!container || !el) return;
  var cRect = container.getBoundingClientRect();
  var tRect = el.getBoundingClientRect();
  var offset = tRect.top - cRect.top - (container.clientHeight / 2) + (el.offsetHeight / 2);
  container.scrollBy({ top: offset, left: 0, behavior: 'smooth' });
};

window.scrollToMessage = function(msgId) {
  var $target = $("#msg_" + msgId);
  if (!$target.length) return;

  var $container = $("#threads_right");
  var containerTop = $container.offset().top;
  var targetTop = $target.offset().top;
  var scrollTop = $container.scrollTop() + (targetTop - containerTop) - 80;

  $container.animate({ scrollTop: scrollTop }, 300, function() {
    $target.addClass("bg-sky-50/80");
    setTimeout(function() {
      $target.removeClass("bg-sky-50/80");
    }, 1500);
  });
};

// ─── Scroll utilities ────────────────────────────────────────────

/** True when the column-reverse message list sits within 80px of the newest message. */
function isNearNewestMessage(element) {
  return Math.abs(element.scrollTop) < 80;
}

/**
 * Scroll to bottom of the messages container.
 * With column-reverse, scrollTop=0 is the bottom (newest messages).
 */
function scrollToBottomEnhanced(element, delay, immediate) {
  if (delay === undefined) delay = 200;
  if (immediate === undefined) immediate = false;
  if (!element || element.length === 0) return;

  var executeScroll = function() {
    var domElement = $(element).get(0);
    if (!domElement) return;

    if (immediate) {
      domElement.scrollTop = 0;
    } else {
      try {
        domElement.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      } catch (e) {
        domElement.scrollTop = 0;
      }
    }
  };

  if (immediate || delay === 0) {
    executeScroll();
  } else {
    setTimeout(executeScroll, delay);
  }
}

function prePositionToBottom(element) {
  // With column-reverse, scrollTop=0 is the bottom
  var domElement = $(element).get(0);
  if (domElement) {
    domElement.scrollTop = 0;
  }
}

function scrollToBottomAfterImagesLoad(element, maxWait) {
  if (maxWait === undefined) maxWait = 3000;
  var $element = $(element);
  var images = $element.find('img');

  if (images.length === 0) {
    scrollToBottomEnhanced(element, 0, true);
    return;
  }

  var loadedImages = 0;
  var startTime = Date.now();

  var checkComplete = function() {
    if (loadedImages >= images.length || (Date.now() - startTime) > maxWait) {
      scrollToBottomEnhanced(element, 0, true);
    }
  };

  images.each(function() {
    if (this.complete) {
      loadedImages++;
    } else {
      $(this).on('load error', function() {
        loadedImages++;
        checkComplete();
      });
    }
  });

  checkComplete();

  setTimeout(function() {
    if (loadedImages < images.length) {
      scrollToBottomEnhanced(element, 0, true);
    }
  }, maxWait);
}

function setupScrollObserver(element) {
  var scrollContainer = $(element).get(0);
  if (!scrollContainer || scrollContainer._scrollObserver) return;

  // Observe #messages_wrapper (direct child additions = new messages) rather
  // than the scroll container with subtree:true, which would fire on every
  // nested DOM change (LucideIcons init, image attribute updates, etc.).
  var wrapper = scrollContainer.querySelector('#messages_wrapper');
  if (!wrapper) return;

  var observer = new MutationObserver(function(mutations) {
    var shouldScroll = false;
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        shouldScroll = true;
      }
    });

    if (shouldScroll && !window.pagedViewActive) {
      // With column-reverse, scrollTop=0 is bottom; negative means scrolled up
      var wasAtBottom = Math.abs(scrollContainer.scrollTop) < 10;
      if (wasAtBottom) {
        scrollContainer.scrollTop = 0;
      }
    }
  });

  observer.observe(wrapper, { childList: true, subtree: false });
  scrollContainer._scrollObserver = observer;
}

window.isNearNewestMessage = isNearNewestMessage;
window.scrollToBottomEnhanced = scrollToBottomEnhanced;
window.prePositionToBottom = prePositionToBottom;
window.scrollToBottomAfterImagesLoad = scrollToBottomAfterImagesLoad;
window.setupScrollObserver = setupScrollObserver;
